import { Routes } from '@angular/router';
import { signedInGuard, SignedOutComponent } from 'shared';
import { HomeComponent } from '@features/home/components/home/home.component';

export const routes: Routes = [
  { path: 'signed-out', component: SignedOutComponent },
  {
    path: 'home',
    canActivate: [signedInGuard],
    component: HomeComponent,
  },
  {
    path: 'stock_locations',
    canActivate: [signedInGuard],
    loadChildren: () => import('./stock-features/locations/routes').then((m) => m.LOCATION_ROUTES),
  },
  {
    path: 'move_goods',
    canActivate: [signedInGuard],
    data: { preload: true },
    loadChildren: () => import('./stock-features/move-goods/routes').then((m) => m.MOVE_GOODS_ROUTES),
  },
  {
    path: 'receipts',
    canActivate: [signedInGuard],
    data: { preload: true },
    loadChildren: () => import('./stock-features/receive-goods/routes').then((m) => m.RECEIVE_GOODS),
  },
  {
    path: 'client_returns',
    canActivate: [signedInGuard],
    loadChildren: () => import('./stock-features/receive-returns/routes').then((m) => m.RECEIVE_RETURNS_ROUTES),
  },
  {
    path: 'deliveries',
    canActivate: [signedInGuard],
    data: { preload: true },
    loadChildren: () => import('./stock-features/shipments/routes').then((m) => m.SHIPMENT_ROUTES),
  },
  {
    path: 'sign_delivery_note',
    canActivate: [signedInGuard],
    data: { preload: true },
    loadChildren: () => import('./stock-features/sign-delivery-note/routes').then((m) => m.SIGN_DELIVERY_NOTE_ROUTES),
  },
  {
    path: 'delivery_notes',
    canActivate: [signedInGuard],
    data: { preload: true },
    loadChildren: () => import('./stock-features/delivery-notes/routes').then((m) => m.DELIVERY_NOTE_ROUTES),
  },
  {
    path: 'pick_orders',
    canActivate: [signedInGuard],
    data: { preload: true },
    loadChildren: () => import('./stock-features/pick-goods/routes').then((m) => m.PICK_GOODS_ROUTES),
  },
  {
    path: 'stock_items',
    canActivate: [signedInGuard],
    loadChildren: () => import('./stock-features/articles/routes').then((m) => m.ARTICLE_ROUTES),
  },
  {
    path: 'stock_corrections',
    canActivate: [signedInGuard],
    loadChildren: () => import('./stock-features/stock-corrections/routes').then((m) => m.STOCK_CORRECTION_ROUTES),
  },
  {
    path: 'link_serial_numbers',
    canActivate: [signedInGuard],
    loadChildren: () =>
      import('./stock-features/link-serial-numbers/routes').then((m) => m.LINK_SERIAL_NUMBERS_ROUTES),
  },
  {
    path: 'undo_pick_orders',
    canActivate: [signedInGuard],
    loadChildren: () => import('./stock-features/undo-picking/routes').then((m) => m.UNDO_PICK_GOODS_ROUTES),
  },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: '**', redirectTo: '/home' },
];
